import Vue from 'vue';

const success = (context, icals) => {
  context.icals = icals;
};


const failed = (context, error) => {
  context.showToasterError(error);
};

export default (context, { rentalId }) => Vue.$http.get(`/icals/${rentalId}`).then((response) => {
  if (response && response.status === 200) {
    success(context, response.data.icals);
  } else {
    failed(context, response);
  }
}).catch(((error) => {
  failed(context, error);
}));



// WEBPACK FOOTER //
// ./src/app/services/rental/getIcals.js